import { render } from "./HaveAQuestionComponent.vue?vue&type=template&id=26d97d32&scoped=true"
import script from "./HaveAQuestionComponent.vue?vue&type=script&lang=js"
export * from "./HaveAQuestionComponent.vue?vue&type=script&lang=js"

import "./HaveAQuestionComponent.vue?vue&type=style&index=0&id=26d97d32&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d97d32"]])

export default __exports__